import React, { useId } from "react";

interface AviciIconProps {
    className?: string;
}

/**
 * Avici protocol mark — a rounded triangle filled with an **angular
 * (conic) gradient** (black → #EAE9E9), which reads as a folded / 3-D
 * facet. SVG has no native conic gradient, so — as Figma exports it —
 * the fill is a CSS `conic-gradient` painted into a `<foreignObject>`
 * and clipped to the triangle path.
 *
 * Because a `<foreignObject>` only renders when the SVG is inline in the
 * DOM (it's suppressed when an SVG is loaded via `<img src>` / data-URL),
 * this mark ships as an inline React component rather than an imported
 * `.svg` asset like the other grayscale icons.
 *
 * `viewBox` is 16×16, matching the icon grid.
 */
export function AviciIcon({ className }: AviciIconProps): React.ReactElement {
    // Unique clip-path id so multiple instances don't collide on `url(#…)`.
    const clipId = useId();
    const trianglePath =
        "M6.09045 3.50933C6.92967 2.01643 9.07919 2.01703 9.91757 3.5104L13.7079 10.262C14.5489 11.76 13.4663 13.6093 11.7484 13.6093H4.24548C2.53084 13.6093 1.4507 11.763 2.29092 10.2683L6.09045 3.50933Z";

    return (
        <svg
            className={className}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g clipPath={`url(#${clipId})`}>
                <g transform="matrix(0.00823063 0.00486355 -0.00545579 0.00923288 8.00497 9.10739)">
                    <foreignObject
                        x="-1041.49"
                        y="-1041.49"
                        width="2082.97"
                        height="2082.97"
                    >
                        <div
                            style={{
                                background:
                                    "conic-gradient(from 90deg, rgba(0,0,0,1) 0deg, rgba(234,233,233,1) 360deg)",
                                height: "100%",
                                width: "100%",
                                opacity: 1
                            }}
                        />
                    </foreignObject>
                </g>
            </g>
            <defs>
                <clipPath id={clipId}>
                    <path d={trianglePath} />
                </clipPath>
            </defs>
        </svg>
    );
}
